import { SpinnerIconContainer } from '@eneco/custom-components/flows/Layout';
import { Box } from '@eneco/sparky';
import { SpinnerIcon } from '@eneco/sparky/icons';

export const FlowSpinner = () => {
  return (
    <SpinnerIconContainer alignY="center" alignX="center">
      <Box paddingBottom="32">
        <SpinnerIcon size="large" color="iconBrand" />
      </Box>
    </SpinnerIconContainer>
  );
};
